import { AppBar } from "@features/dashboard/layouts/AppBar";
import { LessonsExploreScreen } from "@memorang/ui/components/LessonsExploreScreen/LessonsExploreScreen";
import { useRouter } from "expo-router";
import { useLessonsExplore } from "../hooks/useLessonsExplore";

export const LessonsExploreContainer = () => {
	const router = useRouter();
	const explore = useLessonsExplore();

	const handleLessonPress = ({ id }: { id: string }) => {
		router.push(`/modules/${id}`);
	};

	return (
		<>
			<AppBar title="Modules" />
			<LessonsExploreScreen
				title="All modules"
				lessons={explore.lessons}
				totalLessons={explore.totalLessons}
				statusFilter={explore.statusFilter}
				onChangeStatusFilter={explore.onChangeStatusFilter}
				onLessonPress={handleLessonPress}
				onClearFilters={explore.onClearFilters}
			/>
		</>
	);
};
